<script setup lang="ts">
import { onUnmounted, ref } from 'vue'

import AALogo from '@/components/logos/AALogo.vue'

const dots = ref('.')

const interval = setInterval(() => {
  if (dots.value.length === 3) {
    dots.value = ''
  }
  else {
    dots.value += '.'
  }
}, 250)

onUnmounted(() => {
  clearInterval(interval)
})
</script>

<template>
  <div class="relative inset-0 flex flex-col items-center justify-center">
    <div class="relative size-[220px]">
      <AALogo class="w-full" />
    </div>

    <div class="my-12 flex items-center font-medium italic text-gray-500">
      <h1>
        Loading
      </h1>
      <span class="w-4">{{ dots }}</span>
    </div>
  </div>
</template>
